<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tSetMember')"
      ></el-page-header>
    </div>
    <el-card shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('couponList.searchPlaceholder')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div class="flex gap-2">
        <el-button type="primary" @click="addMember">{{ $t("addMember") }}</el-button>
        <el-button type="primary" @click="dialogAddUserVisible = true" class="flex excel-button"
            >
            <img src="@/assets/img/excel-white.svg" alt="" width="16" height="16" /> Excel 추가</el-button
          >
        </div>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:user_gender="slotProps">
          <div>
            {{ user_gender(slotProps.callback.row.user_gender) }}
          </div>
        </template>
        <template v-slot:operation="slotProps">
          <div v-if="slotProps.callback.row.use_time===null" @click="deleteMember(slotProps.callback.row.user_id)">
            <el-tag type="danger">삭제</el-tag>
          </div>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog 
      :title="$t('addMemberModalTitle')" 
      :visible.sync="dialogFormVisible" 
      width="980px"
      @close="handleDialogClose"
    >
      <addMember 
        ref="addMemberComponent"
        @close="closeModal" 
      />
    </el-dialog>
    <el-dialog
      title="사용자 추가"
      :visible.sync="dialogAddUserVisible"
      width="500px"
    >
      <article>
        <div class="flex" style="gap: 4px">
          <div class="disable-input">
            <img src="@/assets/img/excel-color.png" alt="" />
            <p>add_user_coupon_template.xlsx</p>
          </div>
          <a href="/add_user_coupon_template.xlsx" download>
            <el-button type="default">다운로드</el-button>
          </a>
        </div>
        <p class="excel-desc">
          반드시 제공하는 엑셀 파일을 이용해 파일을 업로드 하세요.
        </p>
      </article>
      <article>
        <h3 class="form-label">파일 업로드</h3>
        <div class="input-container">
          <el-input
            v-model="excelFormData.name"
            placeholder="파일 형식 (xlsx)"
            readonly
          />
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx,.xls"
            style="display: none"
            @change="handleFileChange"
          />
          <el-button type="default" @click="triggerFileInput"
            >파일 선택</el-button
          >
        </div>
      </article>

      <div class="button-container">
        <el-button type="default" @click="dialogAddUserVisible = false"
          >취소</el-button
        >
        <el-button type="primary" @click="addUserSubmit">등록하기</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { couponUseList, couponDeleteMember } from "@/api/api";
import addMember from "./addMember.vue";
import { add_user_coupon } from "@/api/api";

export default {
  name: "setMember",
  mixins: [mixin_list(couponUseList)],
  components: {
    myTable,
    page,
    addMember,
  },
  data() {
    return {
      filter: {
        search: "",
        coupon: this.$route.query.id,
      },
      dialogFormVisible: false,
      dialogAddUserVisible: false,
      excelFormData: { name: '' },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("couponList.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("couponList.use_time"),
          sortable: true,
          prop: "use_time",
        },
        {
          label: this.$t("couponList.user_name"),
          sortable: true,
          prop: "user_name",
        },
        {
          label: this.$t("couponList.real_name"),
          sortable: true,
          prop: "real_name",
        },
        {
          label: this.$t("couponList.user_phone"),
          sortable: true,
          prop: "user_phone",
        },
        {
          label: this.$t("couponList.user_gender"),
          sortable: true,
          prop: "user_gender",
          slot: "user_gender",
        },
        {
          label: this.$t("couponList.service_info"),
          sortable: true,
          prop: "service_info",
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 120,
          slot: "operation",
          fixed:'right'
        },
      ],
    };
  },
  methods: {
    user_gender(user_gender) {
      switch (user_gender) {
        case 0:
          return this.$t("couponList.user_gender0");
        case 1:
          return this.$t("couponList.user_gender1");
        case 2:
          return this.$t("couponList.user_gender2");
      }
    },
    addMember() {
      this.dialogFormVisible = true;
    },
    done() {
      this.dialogFormVisible = false;
      this.get_list();
    },

    closeModal() {
      // 자식 컴포넌트의 globalSelectedIds를 clear
      if (this.$refs.addMemberComponent) {
        this.$refs.addMemberComponent.clearGlobalSelection();
      }
      this.dialogFormVisible = false;
      this.get_list();
    },

    handleDialogClose() {
      if (this.$refs.addMemberComponent) {
        this.$refs.addMemberComponent.clearGlobalSelection();
      }
      this.dialogFormVisible = false;
      this.get_list();
    },

    deleteMember(row_id) {
      this.$confirm(this.$t('couponList').sureDeleteCoupon, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await couponDeleteMember(this.$route.query.id, row_id)
        this.get_list()
      }).catch({
      })
    },
    addUserSubmit() {
      // 파일을 읽거나 API로 전송
      const formData = new FormData();
      formData.append('file', this.excelFormData);

      add_user_coupon(formData)
        .then(() => {
          window.location.reload();
        })
        .catch((e) => console.log(e));
    },

    triggerFileInput() {
      const fileInput = this.$refs.fileInput; // 숨겨진 input 참조
      if (fileInput) {
        fileInput.click(); // 파일 입력창 트리거
      }
    },
    handleFileChange(event) {
      const input = event.target;
      if (input.files && input.files.length > 0) {
        this.excelFormData = input.files[0];

        // 파일 크기 및 유형 확인
        if (
          this.excelFormData.type !==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          this.excelFormData.type !== 'application/vnd.ms-excel'
        ) {
          alert('올바른 Excel 파일을 선택하세요.');
          return;
        }
      }
    },

    // async handleClick(type, data) {
    //   switch (type) {
    //     case "add":
    //       this.$router.push('/activityManagement/activityList/edit')
    //       break;
    //     case "edit":
    //       this.$router.push(`/activityManagement/activityList/edit?id=${data.id}`)
    //       break;
    //     case "check":
    //       this.$router.push(`/activityManagement/activityList/detail?id=${data.id}`)
    //       break;
    //   }
    // },
    // async del(id) {
    //   this.$confirm(this.$t('activityList').sureDeleteActivity, this.$t('tips'), {
    //     confirmButtonText: this.$t('btnTips').submit,
    //     cancelButtonText: this.$t('btnTips').cancel,
    //     type: 'warning'
    //   }).then(async () => {
    //     let res = await deleteActivity(id)
    //     this.get_list()
    //   }).catch({
    //   })
    // },
  },
};
</script>
<style scoped>
::v-deep .el-dialog {
  margin-top: 5vh !important;
}

::v-deep .el-dialog__header {
  display: flex;
  justify-content: center;
}

.el-button--default {
  border-radius: 4px;
  background: #919398;

  color: #fff;
}

.el-tag {
  cursor: pointer;
}

.excel-button {
  padding: 12px 8px;
  height: 40px;
}

.excel-button img {
  vertical-align: bottom;
  margin-right: 4px;
}

.button-container {
  display: flex;
  margin-top: 40px;

  button {
    width: 100%;
    height: 50px;
  }
}
.form-label {
  font-family: 'Pretendard-Semibold';
  font-size: 16px;
  color: black;
  margin-bottom: 8px;
}

.input-container {
  display: flex;
  gap: 4px;

  .el-input {
    width: 100%;
  }

  /deep/.el-upload-list {
    display: none;
  }
}

.disable-input {
  display: flex;
  align-items: center;
  padding: 0 12px;
  width: 100%;
  height: 40px;
  gap: 8px;
  border: 1px solid #acb0b3;
  background-color: #f5f5f5;
  border-radius: 4px;

  img {
    width: 24px;
    height: 24px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: black;
  }
}

.excel-desc {
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 12px;
}


</style>